import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const validateItemQuantity = async (data) => {
  try {
    return await postRequest(urls.QUANTITY_VALIDATION, data);
  } catch (err) {
    return err;
  }
};
